<template>
  <div class="the-navbar__user-meta flex items-center ">

    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">Ayuda</p>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="con-img ml-3">

        <feather-icon icon="HelpCircleIcon" class="top--1 cursor-pointer mt-1 pr-5" />

      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown company-dropdown menu-link">
        <ul style="min-width: 9rem" class="link-menu">

          <li
            class="flex py-2 px-4 text-center">
            <span class="ml-2 text-primary text-center">Centro de conocimiento</span>
          </li>
          <a href="https://verificamex.com/es/faqs">
            <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
              <feather-icon icon="HelpCircleIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">FAQ</span>
            </li>
          </a>

          <a href="https://ayuda.verificamex.com">
            <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
              <feather-icon icon="AlertCircleIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">Solicitar Soporte</span>
            </li>
          </a>
          <a href="https://ayuda.verificamex.com">
            <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
              <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">Sugerencias o comentarios</span>
            </li>
          </a>


          <a href="https://www.youtube.com/playlist?list=PLUHQSvk73rHEAtcxvMouawdaBnkzfVUxU" target="_blank">
            <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
                <feather-icon icon="YoutubeIcon" svgClasses="w-4 h-4" />
                <span class="ml-2">Tutoriales (YouTube)</span>
            </li>
          </a>

          <a href="https://blog.verificamex.com/" target="_blank" >
            <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white ">
                <feather-icon icon="BookOpenIcon" svgClasses="w-4 h-4" />
                <span class="ml-2">Blog de Verificamex</span>
            </li>
          </a>

          <a @click="startTour" >
            <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white ">
              <feather-icon icon="EyeIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">Ver Tour</span>
            </li>
          </a>


        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>


  </div>
</template>

<script>

  import Cookies from 'js-cookie';

  export default {
    methods: {
      startTour() {
        Cookies.set('skipTour', false);
        window.location = "/";
      }
    }
  }

</script>

<style lang="scss">
.link-menu{
  a{
    color: #636363!important;
  }
  li:hover{
    a{
      color: #fff!important;

    }
  }
}


.menu-link {
    .vs-dropdown--menu--after {
      right: 19px!important;
    }
}

.top--1{
  margin-top: -1px!important;
}
</style>
